/* global site: false, __: false, app: true, win: true, urlParams: false, pad: false */
$(document).ready(function(){
	var contentCarousels = [],
		imageCarousels = [],
		blockCarousels = [],
		defaultCarousels = [];

	$('.content-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.phone) return;

		var that = $(this),
			rightAlign = that.hasClass('right-align-carousel'),
			carousel = that.owlCarousel({
				autoWidth: true,
				dots: false,
				margin: win.innerWidth() <= app.mediaBreaks.tablet ? 0 : rightAlign || that.hasClass('small-margin') ? 79 : 175,
				nav: false,
				rtl: rightAlign
			});

		contentCarousels.push(carousel);

		that.closest('section').find('.index-carousel-controls .index-control').click(function(){
			$(this).siblings().removeClass('active');
			$(this).addClass('active');
			carousel.trigger('to.owl.carousel', [$(this).index()]);
		});

		that.next().find('.page-control-prev').click(function(){
			carousel.trigger('prev.owl.carousel');
		});

		that.next().find('.page-control-next').click(function(){
			carousel.trigger('next.owl.carousel');
		});

		carousel.on('changed.owl.carousel', function(e){
			that.next().find('.page-count-current').text(e.item.index + 1);
		});
	});

	$('.image-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.phone) return;

		var that = $(this),
			carousel = that.owlCarousel({
				autoWidth: true,
				center: win.innerWidth() > app.mediaBreaks.tablet,
				dots: false,
				loop: true,
				nav: false
			});

		carousel.carouselIndex = 1;

		imageCarousels.push(carousel);

		that.next().find('.page-control-prev').click(function(){
			carousel.carouselIndex -= 1;
			carousel.trigger('prev.owl.carousel');
		});

		that.next().find('.page-control-next').click(function(){
			carousel.carouselIndex += 1;
			carousel.trigger('next.owl.carousel');
		});

		carousel.on('changed.owl.carousel', function(e){
			carousel.carouselIndex = carousel.carouselIndex > e.item.count ? 1 : carousel.carouselIndex < 1 ? e.item.count : carousel.carouselIndex;
			that.next().find('.page-count-current').text(carousel.carouselIndex);
		});
	});

	$('.block-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.tablet) return;

		var that = $(this),
			carousel = that.owlCarousel({
				autoWidth: true,
				dots: false,
				loop: false,
				margin: 0,
				nav: false
			});

		blockCarousels.push(carousel);

		that.next().find('.page-control-prev').click(function(){
			carousel.trigger('prev.owl.carousel');
		});

		that.next().find('.page-control-next').click(function(){
			carousel.trigger('next.owl.carousel');
		});
	});

	$('.default-carousel').each(function(){
		if($(this).hasClass('mobile-static') && win.innerWidth() <= app.mediaBreaks.tablet) return;

		var that = $(this),
			carousel = that.owlCarousel({
				autoWidth: false,
				center: false,
				dots: false,
				items: win.innerWidth() <= app.mediaBreaks.tablet ? 1 : 3,
				loop: false,
				margin: win.innerWidth() <= app.mediaBreaks.tablet ? 0 : 32,
				nav: false,
				responsive: {
					0: {
						items: 1,
						margin: 0
					},
					768: {
						items: 2,
						margin: 32
					},
					1120: {
						items: 3,
						margin: 32
					}
				}
			});

		defaultCarousels.push(carousel);

		that.closest('.container').find('.page-control-prev').click(function(){
			carousel.trigger('prev.owl.carousel');
		});

		that.closest('.container').find('.page-control-next').click(function(){
			carousel.trigger('next.owl.carousel');
		});

		carousel.on('changed.owl.carousel', function(e){
			that.closest('.container').find('.page-count-current').text(e.item.index + 1);
		});
	});
});
